import 'css-chunksrc/client/pages/planzoneParametersPage/organization/form/styles.scss';export default {
  "organization": "_organization_pyhrc_1",
  "row": "_row_pyhrc_5",
  "group": "_group_pyhrc_17",
  "title": "_title_pyhrc_25",
  "text": "_text_pyhrc_31",
  "button": "_button_pyhrc_36"
};